export default __webpack_public_path__ + "static/media/SEC3080.34I-43639_-26074_0.ec557256.jpg";